// extracted by mini-css-extract-plugin
export default {"paymentSection":"S3-z","disabled":"T3-z"};